import React, { useState } from 'react'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import InvitePage from './InvitePage'
import { useInviteLink } from '../../hooks/useInviteLink'

const AuthContainer: React.FC = () => {
  const [isRegisterMode, setIsRegisterMode] = useState(false)
  const { inviteCode, isFromUrl } = useInviteLink()

  // Si hay un código de invitación detectado, mostrar InvitePage
  if (inviteCode && isFromUrl) {
    return <InvitePage inviteCode={inviteCode} />
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {isRegisterMode ? (
          <RegisterForm onSwitchToLogin={() => setIsRegisterMode(false)} />
        ) : (
          <LoginForm onSwitchToRegister={() => setIsRegisterMode(true)} />
        )}
      </div>
    </div>
  )
}

export default AuthContainer 